<template>
  <div>
    <div class="d-flex flex-column align-items-center mb-4">
      <div class="padded-content d-flex flex-column justify-content-center align-items-center">
        <strong class="title mb-2">
          {{ i18n.t('components.image_upload.add_image_title') }}
        </strong>

        <div class="text-center">
          {{ description }}
        </div>
      </div>
    </div>

    <search-stock-image-form :value="currentSearchQuery" @search-image="searchImage" />


    <search-stock-image-results :loading="loadingResults" :results="searchResults"
                                @use-image="useImage" />

    <secondary-button v-if="showNextPageButton" :label="i18n.t('components.image_upload.see_more_results')"
                      class="mt-4 float-end" :disabled="nextPageButtonDisabled" @click="showNextPage" />
  </div>
</template>

<script>
import ajax from '@/helpers/ajax'
import SearchStockImageForm from './search-stock-image-form'
import SearchStockImageResults from './search-stock-image-results'
import SecondaryButton from '@/components/buttons/secondary-button'

const DEFAULT_IMAGES_PER_PAGE = 6

export default {
  components: { SearchStockImageForm, SearchStockImageResults, SecondaryButton },

  props: {
    description: {
      type: String,
      required: false
    },

    searchQuery: {
      type: String,
      required: false,
      default: ''
    },

    externalImageAttributionUtmParams: {
      type: Object,
      required: true
    },

    externalImagePhotoRetrievalUrlWithPlaceholder: {
      type: String,
      required: true
    },

    externalImageSearchUrl: {
      type: String,
      required: true
    },

    imagesPerPage: {
      type: Number,
      required: false,
      default: DEFAULT_IMAGES_PER_PAGE
    }
  },

  emits: ['use-stock-image'],

  data() {
    return {
      currentPage: 1,
      currentSearchQuery: this.searchQuery,
      loadingResults: true,
      searchResults: [],
      totalPages: null
    }
  },

  computed: {
    nextPageButtonDisabled() {
      return this.currentPage === this.totalPages
    },

    showNextPageButton() {
      return !this.loadingResults && this.searchResults.length > 0
    }
  },

  mounted() {
    this.loadResults()
  },

  methods: {
    loadResults() {
      const searchUrl = new URL(this.externalImageSearchUrl)
      const searchParams = new URLSearchParams('')
      searchParams.append('query', this.currentSearchQuery)
      searchParams.append('locale', this.i18n.locale())
      searchParams.append('per_page', this.imagesPerPage)
      searchParams.append('page', this.currentPage)
      searchUrl.search = searchParams.toString()

      this.loadingResults = true

      ajax.get({
        url: searchUrl.toString(),
        successHandler: (response) => {
          this.totalPages = response.totalPages
          this.searchResults = response.results.map((r) => {
            return { id: r.id, urls: r.urls, user: r.user.name }
          })
        }
      }).then(() => {
        // We want to reset the "loading" status whether or not the AJAX call succeeded.
        // If there was a network error, the user can try again.
        this.loadingResults = false
      })
    },

    searchImage(newSearchQuery) {
      this.currentSearchQuery = newSearchQuery
      this.currentPage = 1

      this.loadResults()
    },

    showNextPage() {
      this.currentPage += 1

      this.loadResults()
    },

    useImage(imageId) {
      const photoUrl = new URL(this.externalImagePhotoRetrievalUrlWithPlaceholder.replace(':id', imageId))

      ajax.get({
        url: photoUrl.toString(),
        successHandler: (response) => { 
          const profileUrlWithUtmParams = new URL(response.user.links.html)
          profileUrlWithUtmParams.search = new URLSearchParams(this.externalImageAttributionUtmParams).toString()

          const user = {
            id: response.user.id,
            name: response.user.name,
            profileUrl: profileUrlWithUtmParams.toString()
          }

          this.$emit('use-stock-image', { id: response.id, originalImageUrl: response.urls.raw, user: user })
        }
      })
    }
  }
}
</script>
